import React from "react";
import EnhancedPage from "../../Commen_Component/EnhancedPage";
import { PageEnums } from "../../../_enums/enum.services";

const AreaMaster = () => {

    return <EnhancedPage pageId={PageEnums.AreaList} />
}

export default AreaMaster;